import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function NotFoundPage(): React.JSX.Element {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--bg)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <div
        className="orb"
        style={{
          position: 'absolute',
          inset: 'auto -80px -80px auto',
          width: 'clamp(240px, 36vw, 480px)',
          aspectRatio: '1',
        }}
      />

      <div className="container" style={{ position: 'relative', zIndex: 1 }}>
        <div
          className="stack-5"
          style={{ alignItems: 'center', textAlign: 'center', padding: 'var(--s-10) 0' }}
        >
          <p className="t-label" style={{ margin: 0 }}>404</p>
          <h1 className="t-display-m" style={{ margin: 0 }}>
            You took a <em className="t-italic">wrong</em> turn.
          </h1>
          <p className="t-body t-mute" style={{ maxWidth: '42ch', margin: 0 }}>
            This page doesn&apos;t exist — but your skin analysis is right where you left it.
          </p>
          <div className="row-4" style={{ flexWrap: 'wrap', justifyContent: 'center' }}>
            <button type="button" className="btn btn--primary" onClick={() => { navigate('/'); }}>
              Go home
            </button>
            <button
              type="button"
              className="btn btn--ghost"
              onClick={() => {
                if (window.history.length > 1) navigate(-1);
                else navigate('/');
              }}
            >
              Go back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
